export const LOYALTY_LUX_PLUS_RENEWAL_BONUS_POINTS = 7_500
export const LOYALTY_LUX_PLUS_RENEWAL_BONUS_STATUS_CREDITS = 100

export const LOYALTY_BONUS_POINTS_CAMPAIGN_LABEL: Record<App.LoyaltyBonusPointsCampaignType, string> = {
  static: 'Bonus points',
  double: 'Double points',
  double_status_credits: 'Double status credits',
  triple: 'Triple points',
}
